import * as React from 'react';
import {faTimesCircle} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {GaEventOptions} from '../../../client/ga/ga.functions';

interface FilterChipProps {
    href: string;
    name: string;
    pushGaEvent?: (gaEventOptions: GaEventOptions) => void;
    value: string;
}

export const FilterChip = ({href, name, pushGaEvent, value}: FilterChipProps) => (
    <div className="tw-flex tw-items-center tw-mr-2 tw-p-2 tw-capitalize tw-align-baseline tw-whitespace-nowrap tw-text-center tw-leading-none tw-font-bold tw-rounded-[10rem] tw-bg-gray-600 tw-text-white tw-text-sm tw-w-fit tw-mb-3">
        {name}: {value}{' '}
        <a
            className="tw-text-white"
            href={href}
            onClick={() => {
                if (pushGaEvent) {
                    pushGaEvent({
                        selection_name: `${name}: ${value}`,
                    });
                }
            }}
        >
            <FontAwesomeIcon
                className="tw-pl-2 tw-text-white"
                icon={faTimesCircle}
            />
        </a>
    </div>
);
